import React, { useState, useMemo } from 'react';
import { SearchBar } from 'antd-mobile';
import { debounce, reduce, get } from 'lodash';
import { SearchTableList } from '@/pages/railSetMeal/components';
import { SearchTableListProps } from '@/pages/railSetMeal/components/searchTableList';
import styles from './index.less';

type contentFilteringFieldType = (string | number | readonly (string | number)[])[];

type SearchFilterTableListProps = {
  placeholder?: string;
  cancelText?: string;
  contentFilteringField?: contentFilteringFieldType;
} & SearchTableListProps;

const mergeValueToStr = (data: Record<string, any>, contentFilteringField: any) => {
  try {
    return reduce(
      contentFilteringField || [],
      (sum, n) => {
        return sum + get(data, n);
      },
      '',
    );
  } catch (error) {
    return '';
  }
};

const SearchFilterTableList = (props: SearchFilterTableListProps) => {
  const { contentFilteringField, dataSource, columns, letter, placeholder, cancelText } = props;
  const [searchBarValue, setSearchBarValue] = useState('');

  const handleSearchBar = debounce((value: any) => {
    setSearchBarValue(value);
  }, 1000);

  const dataSourceFilter = useMemo(() => {
    return dataSource?.map((item: Record<string, any>): any => {
      const valueStr = mergeValueToStr(item, contentFilteringField);

      if (!searchBarValue.length) {
        return item;
      }

      if (valueStr.includes(searchBarValue)) {
        return item;
      }
    });
  }, [searchBarValue, dataSource]).filter(Boolean);

  return (
    <div className={styles.searchContent}>
      <div className={`${styles.searchBar} ${styles.mainContentBorder}`}>
        <SearchBar
          placeholder={placeholder}
          cancelText={cancelText}
          onChange={handleSearchBar}
        />
      </div>
      <div className={styles.searchBody}>
        <SearchTableList dataSource={dataSourceFilter} columns={columns} letter={letter} />
        <div className={styles.searchMask}></div>
      </div>
    </div>
  );
};

export default SearchFilterTableList;
